import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SensorGroup, UserGroup, Event, Sensor, SensorGroupInfo, SensorGroupHistory, TimeZoneDisplay as TimeZoneSelection, WaterSchedule, SensorInfo } from '../../shared/models';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { SensorService } from '../../shared/services/sensor.service';
import { SensorGroupService } from '../../shared/services/sensorgroup.service';
import { UserService } from '../../shared/services/user.service';
import { AppComponent } from './../../app.component';
import { TriggerService } from '../trigger-settings/trigger.service';
import { Table } from 'primeng/table';
import { EventMapper } from '../trigger-settings/trigger.mapping';
import { Message, MessageActionType, MessageType, AppComponentName } from '../../shared/models/Messages/message.model';
import { AppMessageService } from '../../shared/services/message.service';
import { HubConnectionState } from '@microsoft/signalr';
import { from, EMPTY, forkJoin } from 'rxjs';
import { Observable } from 'rxjs';
import { HubConnectionFactory } from '../../shared/services/hub-connection-factory.service';
import { SensorReadingsService } from '../sensor-readings/sensor-readings.service';
import { CommonShared } from 'app/shared/classes/common';
import { Authorization } from 'app/shared/classes/authorization';
import { ActivatedRoute } from '@angular/router';
import { SensorMapping } from 'app/shared/classes/sensorMapping';
import { CreateUpdateSensorgroupComponent, CreateUpdateSensorgroupParams } from './create-update-sensorgroup/create-update-sensorgroup.component';
import { DeviceService } from '@services/device.service';
import { DeviceMapping } from 'app/shared/classes/deviceMapping';


interface DateRange {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

@Component({
  standalone: false,
  selector: 'app-sensor-groups',
  templateUrl: './sensor-groups.component.html',
  styleUrls: ['./sensor-groups.component.scss'],
})

export class SensorGroupsComponent implements OnInit {

  @ViewChild('sensorGroupTable') table: Table;

  public common = new CommonShared();
  public auth = new Authorization();
  public mapping = new SensorMapping();
  public deviceMapping = new DeviceMapping();
  
  modalDragOn: boolean = false;

  public searchRecallTimer: any;
  public sensorGroupSearch = '';
  public sensorGroupUpdateDisplayTimer: any;
  public sensorSearch = '';

  public duplicateName = false;
  public eventMapper = new EventMapper();
  public userGroups: UserGroup[] = [];
  public sensorGroups: SensorGroup[] = [];
  public sensorGroupsDisplayed: SensorGroup[] = [];
  public associatedUserGroups: UserGroup[] = [];
  public isDisabled: boolean[] = [false, true];
  public sensorGroupTitle: string;
  public isReadySensorGroups = false;
  //public selectedUserGroup: UserGroup;
  public isReadyEvents = false;
  public isReadyAssociatedUserGroups = false;
  public username = 'unknown';
  public buttonValue: string;
  public isReadyAllSensors = false;
  public sensorGroup: SensorGroup = {} as SensorGroup;
  public scanModalRef: BsModalRef;
  public scannedSensor = '';
  public visitedScan = false;
  public checkSensorGroupUserAssociationStatus = false;
  public globalSwitch = false;
  public allSensorUUIDsDisplayed = false;
  public changedEvents: Event[] = [];
  public changedSensorGroupNames: SensorGroup[] = [];
  public selectedCrop: string;
  public preEditObjectAsJSONString = '';
  public changeLogNotes = '';
  public events: Event[];

  public availableDevices: MediaDeviceInfo[];
  public selectedDevice: MediaDeviceInfo;

  public sensorGroupCols = [
    { field: 'name', header: 'Name', width: '17%' },
    { field: 'description', header: 'Description', width: '17%' },
    { field: 'userName', header: 'Owner', width: '16%' },
    { field: 'crop', header: 'Crop', width: '8%' },
    { field: 'plantAge', header: 'Plant Age', width: '8%' },
    { field: 'sensors', header: '#Sensors', width: '8%' },
    { field: 'modifiedDate', header: 'Modified Date', width: '16%' },
    { field: 'edit', header: '', width: '5%' },
    { field: 'delete', header: '', width: '5%' }
  ];

  locateByNameCols = [
    { field: 'name', header: 'Previous Name', width: '15%' },
    { field: 'startDate', header: 'Start Date', width: '24%' },
    { field: 'endDate', header: 'End Date', width: '24%' },
    { field: 'parentName', header: 'Current Name', width: '17%' },
    { field: 'associatedEvents', header: 'Event(s)', width: '20%' }
  ];

  locateByIDCols = [
    { field: 'name', header: 'Groups', width: '35%' },
    { field: 'sensors.length', header: '#Sensors', width: '12%' },
    { field: 'events', header: 'Associated Events', width: '46%' },
    { field: 'edit', header: 'Edit', width: '7%' }
  ];

  public sensorGroupUUIDs: Sensor[] = [];
  public sensorToAdd: Sensor;
  public allSensors: Sensor[] = [];
  public sensorsDisplayed: Sensor[] = [];
  public groupName: string;
  public searchSensorUUID: string = undefined;
  public searchedSensorUUID = false;
  public sensorGroupsToUpdate: SensorGroup[] = [];
  public userNameTimer: any;
  public searchedRecentNames: boolean = false;
  public recentNamesSearchList: string = undefined;
  public sensorGroupHistory: SensorGroupHistory[] = [];
  public btMacAddressPrefixes: {};
  public readyToImportFileContent: boolean = false;
  public csvFilename: string = '';
  public csvFileContent: string[][] = [];
  public importCSVFileAnalysisResults: string[];
  public analyzingCSVFile: boolean = false;
  public sensorGroupsToImport: SensorGroup[] = [];
  public importingCSVFileContents: boolean = false;
  public waterSchedules: WaterSchedule[] = [];

  modalRef: BsModalRef;
  importModalRef: BsModalRef;

  config = {
    backdrop: false,
    ignoreBackdropClick: true
  };

  locatemodalRef: BsModalRef;
  locateModalconfig = {
    backdrop: false,
    ignoreBackdropClick: true
  };

  public updatedSensorGroupToDisplay: string = "";
  private hubConnection: signalR.HubConnection;


  constructor(public toastr: ToastrService, public modalService: BsModalService, private confirmationService: ConfirmationService, private global: AppComponent,
    public _userService: UserService, public _sensorService: SensorService, public _sensorGroupService: SensorGroupService, public _sensorReadingService: SensorReadingsService,
    private _triggerService: TriggerService, public _appMessageService: AppMessageService, private hubFactory: HubConnectionFactory, private deviceService: DeviceService,
    private route: ActivatedRoute) {
    this.globalSwitch = global.globalSwitch;
    this.linkedSearch = route.snapshot.queryParamMap.get('search');

    this.hubConnection = this.hubFactory.create('/api/hubs/sensorgroup');
    this.hubConnection.onclose(error => console.log('hubConnection.onclose') );
    this.hubConnection.onreconnecting(error => console.log('Attempting reconnect...') );
    this.hubConnection.onreconnected(() => console.log('Reconnected.') );
    this.hubConnection.on('refreshSensorGroup', (updateType: string, updatedSensorGroup: string) => this.refreshSensorGroup(updateType, updatedSensorGroup));
  }


  ngOnInit() {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {

        this.username = results['value'];
        if (this.username != null && this.username != '') {
          this.startUp();
        }
      },
      err => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }


  startUp() {
    this.getBtMacAddressPrefixes();
    //this.loadSavedSettings();
    this.getAssociatedUserGroups();
    this.getAllSensors();
    //this.startTimer4RecallLastSearchFilter();
    //this.getUserGroups();
    this.startSignalR();
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  private startSignalR(): Observable<any> {
    return (this.hubConnection.state === HubConnectionState.Disconnected) ? from(this.hubConnection.start()) : EMPTY;
  }

  public ngOnDestroy() { this.stopSignalR(); }
  private stopSignalR() { this.hubConnection.stop(); }


  private refreshSensorGroup(updateType: string, updatedSensorGroup: string) {
    switch (updateType.toLowerCase()) {
      case "edit":
        this.refreshSensorGroupOnEdit(updatedSensorGroup);
        break;
      case "new":
        this.refreshSensorGroupOnNew(updatedSensorGroup);
        break;
      case "del":
        this.refreshSensorGroupOnDel(updatedSensorGroup);
        break;
      default:
        break;
    }
  }


  public refreshSensorGroupOnEdit(updatedSensorGroup: string) {
    this._sensorGroupService.clearCachedVariables();

    var sensorGroupInfo = this.parseUCaseSensorGroupInfoObj2LCaseSensorGroupInfo(updatedSensorGroup);
    var sensorGroup: SensorGroup = this.mapSensorGroupInfo2SensorGroup(sensorGroupInfo);
    var matchedSensorGroupIndex = this.sensorGroups.findIndex(e => e.id === sensorGroup.id);

    if (matchedSensorGroupIndex < 0) return;

    var existingAssociatedEvents = this.sensorGroups[matchedSensorGroupIndex].events;
    this.sensorGroups[matchedSensorGroupIndex] = sensorGroup;
    this.sensorGroups[matchedSensorGroupIndex].events = existingAssociatedEvents;
    this.sensorGroups = [...this.sensorGroups];

    this.searchSensorGroupsTextChanged();
    this.findSensorGroupsForSensor(this.searchSensorUUID);

    if (sensorGroup.userFeatureAccess["ViewListing"]) {
      this.updatedSensorGroupToDisplay = moment().local().format("hh:mm A") + " -> '" + sensorGroup.name + "' was edited";
      this.startTimer4SensorGroupUpdateDisplay();
      this.toastr.info(sensorGroup.name + " was edited");
    }
  }


  public refreshSensorGroupOnNew(updatedSensorGroup: string) {
    this._sensorGroupService.clearCachedVariables();

    var sensorGroupInfo = this.parseUCaseSensorGroupInfoObj2LCaseSensorGroupInfo(updatedSensorGroup);
    var sensorGroup: SensorGroup = this.mapSensorGroupInfo2SensorGroup(sensorGroupInfo);
    this.sensorGroups = [...this.sensorGroups, sensorGroup];

    this.searchSensorGroupsTextChanged();

    if (sensorGroup.userFeatureAccess["ViewListing"]) {
      this.updatedSensorGroupToDisplay = moment().local().format("hh:mm A") + " -> '" + sensorGroup.name + "' was created";
      this.startTimer4SensorGroupUpdateDisplay();
      this.toastr.info(sensorGroup.name + " was created");
    }
  }


  public refreshSensorGroupOnDel(updatedSensorGroupID: string) {
    this._sensorGroupService.clearCachedVariables();

    var id: number = parseInt(updatedSensorGroupID, 10);
    var sensorGroupIndex = this.sensorGroups.findIndex(e => e.id == id);

    if (sensorGroupIndex > -1) {
      var sensorGroupName = this.sensorGroups[sensorGroupIndex].name;
      if (this.sensorGroups[sensorGroupIndex].userFeatureAccess["ViewListing"]) {
        this.updatedSensorGroupToDisplay = moment().local().format("hh:mm A") + " -> '" + sensorGroupName + "' was deleted";
        this.startTimer4SensorGroupUpdateDisplay();
        this.toastr.info(sensorGroupName + " was deleted");
      }
      this.sensorGroups.splice(sensorGroupIndex, 1);
      this.sensorGroups = [...this.sensorGroups];
      this.searchSensorGroupsTextChanged();
    }
  }


  getBtMacAddressPrefixes(): void {
    this.allSensors = [];
    this._sensorService.getBtMacAddressPrefixes().subscribe(
      results => {
        if (results != null) {
          this.btMacAddressPrefixes = results;
        } else {
          this.toastr.warning('No bluetooth mac address prefixes found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving bluetooth mac address prefixes');
      });
  }


  getSensorGroupSensorCountDisplay(sensorGroup: SensorGroup): string {
    if (sensorGroup.sensors == undefined || sensorGroup.sensors.length < 1) {
      return "0 / 0";
    }
    else {
      var total = sensorGroup.sensors.length;
      var ignored = sensorGroup.sensors.filter(x => x.ignore).length;
      return `${total - ignored} / ${total}`;
    }
  }

  public parseUCaseSensorGroupInfoObj2LCaseSensorGroupInfo(sensorGroupInfoStr: string): SensorGroupInfo {
    const sensorGroup = JSON.parse(sensorGroupInfoStr);

    var sensorGroupInfo: SensorGroupInfo = {
      id: sensorGroup.ID,
      name: sensorGroup.Name,
      description: sensorGroup.Description,
      createdDate: sensorGroup.CreatedDate,
      modifiedDate: sensorGroup.ModifiedDate,
      isDisabled: sensorGroup.IsDisabled,
      plantDate: sensorGroup.PlantDate,
      beginDate: sensorGroup.BeginDate,
      endDate: sensorGroup.EndDate,
      crop: sensorGroup.Crop,
      uuids: sensorGroup.UUIDs,
      userName: sensorGroup.UserName,
      userGroupID: sensorGroup.UserGroupId,
      sensors: []
    }
    
    sensorGroup.Sensors.forEach(x => {
      var ucaseSensor: SensorInfo = {
        id: x.ID,
        uuid: x.UUID,
        name: x.Name,
        type: x.Type,
        source: x.Source,
        sensorReadingTypes: [],
        modifiedDate: x.ModifiedDate,
        userGroupId: x.UserGroupId,
        userName: x.UserName,
        ignore: x.Ignore,
        ignoreUntil: x.IgnoreUntil,
        //virtualSensor: undefined,
        sensorCalibrationHistory: null,
        referenceInfo: '',
        gpsLocation: undefined,
        notes: '',
        virtualSensorInfo: undefined
      }

      sensorGroupInfo.sensors.push(ucaseSensor);
    });
    
    return sensorGroupInfo;
  }


  openScanModal(template: TemplateRef<any>): void {
    this.scanModalRef = this.modalService.show(template);
    this.scannedSensor = '';
  }


  public addSensor(): void {
    if (this.scannedSensor == undefined || this.scannedSensor == '') {
      this.toastr.warning('Please scan a sensor');
      return;
    }
    this.scannedSensor = this.createUUID(this.scannedSensor);
    this.allSensors.forEach(sensor => {
      if (sensor['uuid'].toLowerCase() === this.scannedSensor.toLowerCase()) {
        const sensorIndex = this.allSensors.indexOf(sensor);
        sensor['checked'] = true;
        this.sensorToAdd = sensor;
        this.scannedSensor = '';
        this.allSensors.splice(sensorIndex, 1);
        this.allSensors.unshift(this.sensorToAdd);
        this.toastr.success('Sensor found in database and adding to list');
        return;
      }
    });
    if (!(this.scannedSensor == '')) {
      this.sensorToAdd = {
        id: 0,
        uuid: this.scannedSensor.toLowerCase(),
        sensorReadingTypes: undefined,
        sensorReadingTypeNames: '',
        checked: true,
        modifiedDate: new Date(),
        userName: this.username,
        userGroupId: undefined,
        virtualSensor: undefined,
        sensorCalibrationHistory: null,
        lastReading: this.common.createNewLastReading(0)
      };
      this.allSensors.unshift(this.sensorToAdd);
      this.toastr.success('Successfully added new sensor');
      this.scannedSensor = '';
    }
  }


  duplicateNamecheck(name: string): boolean {
    this.duplicateName = false;
    this.sensorGroups.forEach(s => {
      if (s.name.toUpperCase() == name.toUpperCase() && s.id != this.sensorGroup.id){
        this.toastr.error('Sensor Group name is already in use');
        this.duplicateName = true;
        return this.duplicateName;
      }
    });
    return this.duplicateName;
  }


  public scannedSensorQR(): void {
    if (this.scannedSensor == undefined || this.scannedSensor == '') {
      this.toastr.warning('Please scan a sensor');
      return;
    }

    this.searchSensorUUID = this.scannedSensor;
    this.scanModalRef.hide();
  }


  public createUUID(uuid): string {
    uuid = uuid.split(':').join('');
    const formattedUUID = [];
    const maxLength = 36;
    let uuidLengthTracker = uuid.length - 1;
    for (let i = 0; i <= maxLength - 1; i++) {
      if (i == 12 || i == 17 || i == 22 || i == 27) {
        formattedUUID.unshift('-');
      } else if (uuidLengthTracker >= 0) {
        formattedUUID.unshift(uuid.charAt(uuidLengthTracker));
        uuidLengthTracker--;
      } else {
        formattedUUID.unshift('0');
      }
    }
    return formattedUUID.join('');
  }


  public scanComplete(event: string): void {
    this.visitedScan = false;
    if (this.scannedSensor == '') {
      const splitEvent = this.createUUID(event);
      this.allSensors.forEach(sensor => {
        if (sensor['uuid'].toLowerCase() === splitEvent.toLowerCase() && sensor['checked'] == true) {
          this.toastr.error('This sensor is already selected');
          this.visitedScan = true;
          return;
        }
      });
      if (!this.visitedScan) {
        this.toastr.success('Scanned ' + event);
        this.scannedSensor = event;
        this.visitedScan = false;
      }
    } else {
      this.toastr.warning('Please choose to add or ignore current sensor');
    }

  }

  public camerasFound(cameras: MediaDeviceInfo[]) {
    this.availableDevices = cameras;
    if (this.availableDevices.length > 0) {
      this.onDeviceSelectChange(this.availableDevices[this.availableDevices.length-1].deviceId);
    }
  }


  onDeviceSelectChange(selectedValue: string) {
    this.selectedDevice = this.availableDevices.find(x => x.deviceId == selectedValue);
  }


  ignoreSensor(): void {
    if (this.scannedSensor == '') {
      this.toastr.warning('Please scan a sensor');
    } else {
      this.toastr.warning('Ignored ' + this.scannedSensor);
      this.scannedSensor = '';
    }
  }


  onCancelButton() {
    this.modalRef.hide();
  }


  getSensorGroups(): void {
    var forceReload = true;
    this._sensorGroupService.getSensorGroupsWithSensors(forceReload).subscribe(
      results => {
        if (results != null) {
          this.sensorGroups = results;
          this.sensorGroups.forEach(x => {
            this.auth.mapUserAccessForSensorGroup(x, this.globalSwitch, this.username, this.userGroups);
          });

          this.startTimer4RecallLastSearchFilter();
          //this.getEvents();
          this.getWaterSchedules();
          this.isReadySensorGroups = true;
        } else {
          this.toastr.warning('No Sensor Groups found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  getAssociatedUserGroups(): void {
    this._userService.getAssociatedUserGroups(this.username).subscribe(
      results => {
        if (results != null) {
          this.isReadyAssociatedUserGroups = true;
          this.associatedUserGroups = results;
          this.getUserGroups();
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  getUserGroups(): void {
    this._userService.getUserGroups().subscribe(
      results => {
        if (results != null) {
          this.userGroups = results;
          this.getSensorGroups();
        }
        else {
          this.toastr.warning('No user groups found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving all user groups');
      });
  }


  getAllSensors(): void {
    this._sensorService.getAllSensorsWithoutTypes().subscribe(
      results => {
        if (results != null) {
          this.allSensors = this.mapping.mapSensorInfos2Sensors(results, undefined);

          this.allSensors.forEach(s => {
            if (s.sensorReadingTypes == null) {
              s.sensorReadingTypes = [];
            }
          });
          this.isReadyAllSensors = true;
        } else {
          this.toastr.warning('No Sensor Groups found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  getFormattedDate(date: Date): string {
    const dateFormatted = moment(date).local().format('YYYY-MM-DD HH:mm');
    return dateFormatted;
  }


  addSensorGroup(template: TemplateRef<any>) {
    this.sensorGroup = this.newSensorGroup();
    
    const params: CreateUpdateSensorgroupParams = {
      sensorGroup: this.sensorGroup,
      sensorGroups: this.sensorGroups,
      sensorGroupHistory: this.sensorGroupHistory,
      userGroups: this.userGroups,
      associatedUserGroups: this.associatedUserGroups,
      modalMode: "Create",
      allSensors: this.allSensors,
      events: this.events,
      btMacAddressPrefixes: this.btMacAddressPrefixes
    };

    this.modalService.show(CreateUpdateSensorgroupComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  editSensorGroup(sensorGroup: SensorGroup, template: TemplateRef<any>) {
    const params: CreateUpdateSensorgroupParams = {
      sensorGroup: sensorGroup,
      sensorGroups: this.sensorGroups,
      sensorGroupHistory: this.sensorGroupHistory,
      userGroups: this.userGroups,
      associatedUserGroups: this.associatedUserGroups,
      modalMode: "Update",
      allSensors: this.allSensors,
      events: this.events,
      btMacAddressPrefixes: this.btMacAddressPrefixes
    };

    this.modalService.show(CreateUpdateSensorgroupComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  newSensorGroup(): SensorGroup {
    var sensorGroup: SensorGroup = {
      id: 0,
      name: '',
      description: '',
      createdDate: moment().local().toDate(),
      modifiedDate: moment().local().toDate(),
      beginDate: moment().local().toDate(),
      endDate: moment().local().add(10, 'years').toDate(),
      isDisabled: false,
      crop: '-',
      plantDate: undefined,
      plantAge: 0,
      userGroupId: 0,
      userGroup: undefined,
      userAccess: undefined,
      userName: this.username,
      events: [],
      sensors: [],
      isNew: true
    };

    this.auth.mapUserAccessForSensorGroup(sensorGroup, this.globalSwitch, this.username, this.userGroups);

    return sensorGroup;
  }


  locateSensorGroup(template: TemplateRef<any>) {
    this.searchSensorUUID = undefined;
    this.sensorGroupsToUpdate = [];
    this.searchedSensorUUID = false;
    this.changedSensorGroupNames = [];
    this.changedEvents = [];
    this.locatemodalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  findSensorGroupsForSensor(sensorUUID: string) {
    if (sensorUUID) {
      const toMatchString = this.parseSensorUUID(sensorUUID);

      const sensorGroupIdsForSensor: number[] = [];
      this.sensorGroups.forEach(g => {
        g.sensors.forEach(s => {
          if (s.uuid.toLowerCase().includes(toMatchString)) {
            sensorGroupIdsForSensor.push(g.id);
          }
        });
      });

      this.sensorGroupsToUpdate = JSON.parse(JSON.stringify(this.sensorGroups.filter(x => sensorGroupIdsForSensor.includes(x.id))));
      this.searchedSensorUUID = true;

      const element: HTMLElement = document.getElementById('SearchInput') as HTMLElement;
      element.blur();
    }
  }


  parseSensorUUID(sensorUUID: string): string {
    const matchExp = '[a-zA-Z][-]';
    const matchesPattern = sensorUUID.substring(0, 2).search(matchExp) >= 0;
    const toReplacePattern = new RegExp('[;\\\\/:*?"<>|&\']');
    if (matchesPattern) {
      return sensorUUID.substring(2, sensorUUID.length).toLowerCase().replace(/:/g, '');
    }
    return sensorUUID.toLowerCase().replace(/:/g, '');
  }


  searchSensorUUIDChanged() {
    this.sensorGroupsToUpdate = [];
    this.searchedSensorUUID = false;
    this.changedSensorGroupNames = [];
    this.changedEvents = [];
  }


  locateSensorGroupHistoryByName(template: TemplateRef<any>) {
    this.recentNamesSearchList = "";
    this.searchedRecentNames = false;
    this.locatemodalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  findSensorGroupByRecentName() {
    if (this.recentNamesSearchList) {
      var recentGroupNames: string[] = this.recentNamesSearchList.split(',');
      this.searchSensorGroupHistoryByName(recentGroupNames);
    }
  }


  replaceSearchStringSpacesWithCommas() {
    this.recentNamesSearchList = this.recentNamesSearchList.replace(/\s+/g, ",").toLowerCase();
  }


  recentNamesSearchListChanged() {
    this.searchedRecentNames = false;
  }


  searchSensorGroupHistoryByName(recentGroupNames: string[]): void {
    this._sensorGroupService.searchSensorGroupHistoryByName(recentGroupNames).subscribe(
      results => {
        if (results != null) {
          this.sensorGroupHistory = results;
          this.sensorGroupHistory.forEach(g => {
            var currentGroup = this.sensorGroups.find(x => x.id == g.parentId);

            if (currentGroup == undefined) {
              g.parentName = "-no longer exists-";
            }
            else {
              g.parentId = currentGroup.id;
              g.parentName = currentGroup.name;
            }

            g.startDate = moment.utc(g.startDate).local().format("YYYY-MM-DDTHH:mm");
            g.endDate = moment.utc(g.endDate).local().format("YYYY-MM-DDTHH:mm");

            if (g.id < 1) {
              g.endDate = undefined;
              g.name = g.parentName;
            }

            g.associatedEvents = (currentGroup != undefined && currentGroup.events != undefined) ? currentGroup.events.map(x => x.name) : []
          });
          
          this.searchedRecentNames = true;
        } else {
          this.toastr.warning('No history found for sensor group(s)');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving sensor group history');
      });
  }


  sensorGroupNameChanged(changedSensorGroup: SensorGroup) {
    const existingInchangedSensorGroupNames = this.changedSensorGroupNames.filter(x=>x.id == changedSensorGroup.id)[0];

    if (existingInchangedSensorGroupNames != undefined) {
      existingInchangedSensorGroupNames.name = changedSensorGroup.name;
    } else {
      this.changedSensorGroupNames.push(changedSensorGroup);
    }
  }


  sensorGroupEnableChanged(changedSensorGroup: SensorGroup) {
    const existingInchangedSensorGroupNames = this.changedSensorGroupNames.filter(x=>x.id == changedSensorGroup.id)[0];

    if (existingInchangedSensorGroupNames != undefined) {
      existingInchangedSensorGroupNames.isDisabled = !changedSensorGroup.isDisabled;
    } else {
      changedSensorGroup.isDisabled = !changedSensorGroup.isDisabled;
      this.changedSensorGroupNames.push(changedSensorGroup);
    }
  }


  triggerEnableChanged(sensorGroup: SensorGroup, modifiedTrigger: Event) {
    const changedEvents = this.changedEvents.filter(x=>x.id == modifiedTrigger.id)[0];

    if (changedEvents != undefined) {
      changedEvents.isDisabled = modifiedTrigger.isDisabled; // !modifiedTrigger.isDisabled;
    } else {
      modifiedTrigger.isDisabled = modifiedTrigger.isDisabled; // !modifiedTrigger.isDisabled;
      this.changedEvents.push(modifiedTrigger);
    }
  }


  isEnabled(sensorGroup: SensorGroup){
    return !sensorGroup.isDisabled;
  }


  updateChangedSensorGroupsAndTriggers() {
    var eventPlusSensorGroupCalls: any[] = [];

    this.changedEvents.forEach(event => {
      event.sensorConditions.forEach(c => c.sensorGroup = this.sensorGroups.find(x => x.id == c.sensorGroupID));
      eventPlusSensorGroupCalls.push(this._triggerService.updateEvent(this.eventMapper.mapEvent2EventInfo(event), 'Updating event ...', this.username));
      event.sensorConditions.forEach(c => c.sensorGroup = undefined);

      var eventIndex = this.events.findIndex(e => e.id == event.id);
      if (eventIndex > -1) {
        this.events[eventIndex] = event;
      }
    });

    this.changedSensorGroupNames.forEach(sensorgroup => {
      sensorgroup.plantDate = moment().subtract(21, 'days').toDate();
      sensorgroup.plantAge =  -1 * moment.utc(sensorgroup.plantDate).local().diff(moment(),'days');
      sensorgroup.modifiedDate = new Date();
      const createUpdateSensorGroup = this.common.mapSensorGroup2SensorGroupInfo(sensorgroup);
      eventPlusSensorGroupCalls.push(this._sensorGroupService.updateSensorGroup(createUpdateSensorGroup, this.username));
    });

    forkJoin(eventPlusSensorGroupCalls).subscribe(
      results => {
        this.addEventsToSensorGroups(this.events);

        for (var index = 0; index < this.changedEvents.length; index++) {
          var event = this.changedEvents[index];
          if (results[index] != null) {
            this.sensorGroups.forEach(sensorGroup => {
              var sensorGroupIndex = sensorGroup.events.findIndex(e => e.id == event.id);
              if (sensorGroupIndex > -1) {
                this.createMessageData(MessageActionType.Edited, sensorGroup, `Event: ${event.name}, Enabled (${event.isDisabled} -> ${!event.isDisabled})`);
              }
            });
            this.toastr.success('Event updated: ' + event.name);
          }
          else {
            this.toastr.warning('Event update returned no results for ' + event.name);
            this.createMessageData(MessageActionType.Edited, sensorgroup, `Warning: Did not receive a success after change for Event: ${event.name}`);
          }
        }

        for (var index = this.changedEvents.length; index < results.length; index++) {
          var sensorgroup = this.changedSensorGroupNames[index - this.changedEvents.length];
          if (results[index] != null) {
            this.createMessageData(MessageActionType.Edited, sensorgroup, 'Name (x -> ' + sensorgroup.name + ')');
            this.toastr.success('Sensor Group updated:' + sensorgroup.name);
          }
          else {
            this.toastr.warning('Sensor Group update returned no results for ' + sensorgroup.name);
            this.createMessageData(MessageActionType.Edited, sensorgroup, `Warning: Did not receive a success after name change for Sensor Group: ${sensorgroup.name}`);
          }
        }

        this._sensorGroupService.clearCachedVariables();
        this.getSensorGroups();
        this.locatemodalRef.hide();
      },
      err => {
        this.toastr.error('Error occurred while updating Sensor Groups and/or Event state');
        this.createMessageData(MessageActionType.Edited, undefined, 'Locate by Sensor ID Error.  #Events=' + this.changedEvents.length + '  #Sensor Group Names=' + this.changedSensorGroupNames.length);
      });
  }


  mapSensorGroupInfo2SensorGroup(sensorGroupInfo: SensorGroupInfo): SensorGroup {
    const newSensorGroup: SensorGroup = {
      id: sensorGroupInfo.id,
      name: sensorGroupInfo.name,
      description: sensorGroupInfo.description,
      createdDate: moment.utc(sensorGroupInfo.createdDate).local().toDate(),
      modifiedDate: moment.utc(sensorGroupInfo.modifiedDate).local().toDate(),
      isDisabled: sensorGroupInfo.isDisabled,
      crop: (sensorGroupInfo.crop == null || sensorGroupInfo.crop == '') ? '-' : sensorGroupInfo.crop,
      plantDate: moment.utc(sensorGroupInfo.plantDate).local().toDate(),
      plantAge: (sensorGroupInfo.plantDate != null) ? -1 * moment.utc(sensorGroupInfo.plantDate).local().diff(moment(),'days') : null,
      beginDate: moment.utc(sensorGroupInfo.beginDate).local().toDate(),
      endDate: moment.utc(sensorGroupInfo.endDate).local().toDate(),
      userGroupId: sensorGroupInfo.userGroupID,
      userGroup: '',
      userAccess: null,
      userName: sensorGroupInfo.userName,
      events: [],
      sensors: this.mapping.mapSensorInfos2Sensors(sensorGroupInfo.sensors, null)
    };

    this.addEventsToSensorGroups(this.events);
    this.auth.mapUserAccessForSensorGroup(newSensorGroup, this.globalSwitch, this.username, this.userGroups);

    return newSensorGroup;
  }


  onDeleteConfirm(sensorGroup, template) {
    if (sensorGroup.events.length > 0) {
      this.sensorGroup = sensorGroup;
      this.modalRef = this.modalService.show(template, this.config);
    }
    else {
      this.confirmationService.confirm({
        message: 'Confirm.  Delete the sensor group \'' + sensorGroup.name + '\'?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',

        accept: () => {
          this._sensorGroupService.deleteSensorGroup(sensorGroup, this.username).subscribe(
            results => {
              if (results != null) {
                this.createMessageData(MessageActionType.Deleted, sensorGroup, '');
                this.toastr.success('Success');
              } else {
                this.toastr.warning('No Sensor Groups found.');
              }
              return;
            },
            err => {
              this.toastr.error('Error occurred while deleting sensor group. Reload page');
            });
        },
        reject: () => {
        }
      });
    }
  }


  getOwnerName(sensorgroup: SensorGroup): string {
    if (sensorgroup.userGroupId != null) {
      return sensorgroup.userGroup;
    } else {
      return sensorgroup.userName;
    }
  }


  getWaterSchedules(): void {
    this.deviceService.getGlobalWaterSchedules().subscribe(
      results => {
        if(results.length != 0 && results != null){
          this.waterSchedules = this.deviceMapping.mapWaterScheduleInfos2WaterSchedules(results);
        }
        this.getEvents();
      },
      err => {
        this.toastr.error('Error occurred while retrieving irrigation schedule data from the server.');
      });
  }


  getEvents() {
    var forceReload = true;
    this._triggerService.getEvents('Loading Events ...', forceReload).subscribe(
      results => {
        if (results != null) {
          const eventMapper = new EventMapper();
          this.events = eventMapper.mapEventInfos2Events(results);

          this.events.forEach(x => {
            x.eventActions.forEach(a => {
              a.schedule = this.waterSchedules.find(s => s.id == a.scheduleID);
            });
          });

          this.addEventsToSensorGroups(this.events);
          this.sensorGroups.forEach(s => {
            s.events.forEach(e => {
              this.auth.mapUserAccessForEvent(e, this.globalSwitch, this.username, this.userGroups);
            });
          });
          this.isReadyEvents = true;
        } else {
          this.toastr.warning('No Events found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving Events.');
      });
  }


  addEventsToSensorGroups(events: Event[]) {
    events.forEach( t => {
      t.sensorConditions.forEach(s => {
        const groupIndex = this.sensorGroups.findIndex(g => g.id == s.sensorGroupID); // s.sensorGroup.id);

        if (groupIndex >= 0) {
          const eventIndex = this.sensorGroups[groupIndex].events.findIndex(event => event.id == t.id);

          if (eventIndex < 0) {
            this.sensorGroups[groupIndex].events.push(t);
          } else {
            this.sensorGroups[groupIndex].events[eventIndex] = t;
          }
        }
      });
    });
  }


  searchBoxTextChanged() {
    localStorage.setItem('SensorGroupSearchBox', this.sensorGroupSearch);
  }


  // Search text passed in by a link (e.g. from the home page search), used once in place of the saved search
  private linkedSearch: string | null = null;


  startTimer4RecallLastSearchFilter() {
    this.searchRecallTimer = setTimeout(() => {
      if (this.table != null) {
        this.sensorGroupSearch = this.linkedSearch ?? localStorage.getItem('SensorGroupSearchBox');
        this.linkedSearch = null;
        if (this.sensorGroupSearch == undefined) {
          this.sensorGroupSearch = "";
        }
        this.searchSensorGroupsTextChanged();
      }
    },500);
  }


  startTimer4SensorGroupUpdateDisplay() {
    if (this.sensorGroupUpdateDisplayTimer) {
      clearInterval(this.sensorGroupUpdateDisplayTimer);
    }
    this.sensorGroupUpdateDisplayTimer = setInterval(() => {
      this.updatedSensorGroupToDisplay = "";
      clearInterval(this.sensorGroupUpdateDisplayTimer);
    }, 120000);
  }


  clearSearchFilter() {
    this.sensorGroupSearch = '';
    this.searchSensorGroupsTextChanged();
  }


  searchSensorGroupsTextChanged() {
    var searchResults: SensorGroup[] = [];
    const searchLimit = 1000;
    let checkedCount = 0;

    if (this.sensorGroupSearch == undefined || this.sensorGroupSearch == '' || this.sensorGroupSearch == 'null') {
      searchResults = [];
    }
    else if (this.sensorGroupSearch == '*') {
      localStorage.setItem('SensorGroupSearchBox', '');
      searchResults = this.sensorGroups;
    }
    else {
      localStorage.setItem('SensorGroupSearchBox', this.sensorGroupSearch);
      searchResults = this.sensorGroups.filter(s => (s.name != undefined ? s.name.toLowerCase().includes(this.sensorGroupSearch.toLowerCase()) : false) ||
                                                    (s.description != undefined ? s.description.toLowerCase().includes(this.sensorGroupSearch.toLowerCase()) : false));
    }

    const displayCount = (searchResults.length > checkedCount + searchLimit) ? checkedCount + searchLimit : searchResults.length;

    var sensorGroupIds = searchResults.slice(0, displayCount).map(x => x.id);
    this.sensorGroupsDisplayed = this.sensorGroups.filter(x => sensorGroupIds.includes(x.id));
  }


  createMessageData(msgActionType: MessageActionType, sensorGroup: SensorGroup, msgNote: string) {
    const message: Message = {
      id: 0,
      messageType: MessageType.Audit,
      appComponentName: AppComponentName.SensorGroups,
      actionType: msgActionType,
      appComponentItem: (sensorGroup != undefined) ? sensorGroup.name : '',
      details: msgNote,
      userNotes: this.changeLogNotes,
      count: 1,
      acknowledged: false,
      userName: this.username,
      userGroupId: (sensorGroup != undefined) ? sensorGroup.userGroupId : null,
    };

    this._appMessageService.createAppMessage(message).subscribe(
      results => {
        if (results != null) {
          //this.toastr.success('Success');
        } else {
          //this.toastr.warning('Not found.');
        }
        return;
      },
      err => {
        //this.toastr.error('Error occurred while saving change log.');
      });
  }


  importSensorGroupInfo(template: TemplateRef<any>) {
    this.readyToImportFileContent = false;
    this.importCSVFileAnalysisResults = [];
    this.importModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  csvFileSelected(fileEvent) {
    this.loadCSVFile(fileEvent);
  }


  loadCSVFile(fileEvent) {
    this.csvFilename = '';
    this.csvFileContent = [];
    this.importCSVFileAnalysisResults = [];

    const fileReader = new FileReader();
    fileReader.onload = (content: any) => {
      var records: string[] = content.target.result.split('\n');
      records.forEach(x => {
        var record = x.replace(/\r/g, '')

        if (record.length > 0) {

          var fields = record.split(',').map(field => field.trim());
          this.csvFileContent.push(fields);
        }
      });

      if (this.preCheckCSVContentAnalysis()) {
        this.analyzeFileContent();
        this.readyToImportFileContent = true;
      }

    };

    if (fileEvent.target.files.length > 0) {
      this.analyzingCSVFile = true;
      this.csvFilename = fileEvent.target.files[0].name;
      fileReader.readAsText(fileEvent.target.files[0]);
    }
  }


  preCheckCSVContentAnalysis(): boolean {
    this.analyzingCSVFile = true;

    if (this.csvFileContent.length < 2) {
      this.toastr.error('Error: Can not import. Must have a header row and at least one data row');
      this.importCSVFileAnalysisResults.push("Error: Can not import. Must have a header row and at least one data row.");
      this.analyzingCSVFile = false;
      return false;
    }

    var missingFields = this.validateRequiredFields(this.csvFileContent[0]).join(', ');
    if (missingFields != '') {
      this.toastr.error('Error: First row missing required fields (' + missingFields + ')');
      this.importCSVFileAnalysisResults.push('Error: First row missing required fields (' + missingFields + ')');
      this.analyzingCSVFile = false;
      return false;
    }

    return true;
  }


  validateRequiredFields(headerRecord: string[]): string[] {
    var results: string[] = [];

    var searchItems = [ 'Name', 'Description', 'UserGroup', 'UUIDs' ];

    searchItems.forEach(s => {
      if (headerRecord.findIndex(x => x.toLowerCase() == s.toLowerCase()) == -1) {
        results.push(s);
      }
    });

    return results;
  }


  analyzeFileContent() {
    var counter: number;
    this.sensorGroupsToImport = [];

    var mappedFields = this.mapFieldColumns(this.csvFileContent[0]);

    for (counter=1; counter < this.csvFileContent.length; counter++) {
      var csvFileLine = this.csvFileContent[counter];
      var existingSensorGroup = this.sensorGroupsToImport.find(x => x.name.toLowerCase() == csvFileLine[mappedFields["name"]].toLowerCase());
      
      if ((csvFileLine[mappedFields["action"]].toLowerCase() == 'add' || csvFileLine[mappedFields["action"]].toLowerCase() == 'append') && existingSensorGroup != undefined) {
        // if sensorGroup already in the this.sensorGroupsToImport list, then just add the new sensors to the existing sensorGroup in the list (do not create a new sensorGroup object)
        
        var uuids: string[] = csvFileLine[mappedFields["uuids"]].split(';').map(field => field.trim());
        uuids.forEach(uuid => { existingSensorGroup.sensors.push(this.findOrCreateSensor(uuid)); });
      }
      else {
        var sensorGroup = this.createOrUpdateSensorGroupWithCSVFileContent(csvFileLine, mappedFields);
        this.sensorGroupsToImport.push(sensorGroup);
      }
    };

    this.importCSVFileAnalysisResults.push(`Sensor groups in file: ${this.sensorGroupsToImport.length}`);
    this.importCSVFileAnalysisResults.push(`New groups: ${this.sensorGroupsToImport.filter(x => x.isNew).length}`);
    this.importCSVFileAnalysisResults.push(`Existing groups: ${this.sensorGroupsToImport.filter(x => !x.isNew).length}`);
    this.importCSVFileAnalysisResults.push(`Groups with missing data: ${this.sensorGroupsToImport.filter(x => x.name == '' || x.sensors == undefined || x.sensors.length < 1).length}`);
    this.importCSVFileAnalysisResults.push(`Have permission to update: ${this.sensorGroupsToImport.filter(x => x.userFeatureAccess["EditSensorGroup"]).length}`);
    
    this.analyzingCSVFile = false;
  }


  mapFieldColumns(csvFileLine: string[]): { [key: string] : number } {
    var searchItems = [ 'Name', 'Description', 'UserGroup', 'UUIDs', 'StartDate', 'EndDate', 'Action' ];
    var headerDictionary: { [key: string] : number } = {};

    searchItems.forEach(x => {
      var index = csvFileLine.findIndex(y => y.toLowerCase() == x.toLowerCase());

      headerDictionary[x.toLowerCase()] =  index;
    });

    return headerDictionary;
  }


  findOrCreateSensor(uuid: string): Sensor {
    var sensor = this.allSensors.find(y => y.uuid.toLowerCase() == uuid.toLowerCase());

    if (sensor != undefined) {
      return sensor;
    }
    else {
      var newSensor = this.newSensor(uuid);
      this.allSensors.push(newSensor);
      return newSensor;
    }
  }


  createOrUpdateSensorGroupWithCSVFileContent(csvFileLine: string[], mappedFields: { [key: string] : number } ): SensorGroup {
    var sensorGroup: SensorGroup;

    var existingSensorGroup = this.sensorGroups.find(x => x.name.toLowerCase() == csvFileLine[mappedFields["name"]].toLowerCase());

    if (existingSensorGroup != undefined) {
      sensorGroup = this.common.cloneSensorGroup(existingSensorGroup);
    }
    else {
      sensorGroup = this.newSensorGroup();
      sensorGroup.name = csvFileLine[mappedFields["name"]];
      //this.sensorGroups.push(sensorGroup);  // Need to add the new sensor group so that it can be found in the list when processing the next line of the CSV file (in case there are multiple lines for the same sensor group)
    }

    if (sensorGroup.userFeatureAccess["EditSensorGroup"] || sensorGroup.isNew) {
      var selectedUserGroup = this.userGroups.find(x => x.name.toLowerCase() == csvFileLine[mappedFields["usergroup"]].toLowerCase() );
      this.common.updateUserInfoForSensorGroup(sensorGroup, selectedUserGroup, this.username);
    }

    this.auth.mapUserAccessForSensorGroup(sensorGroup, this.globalSwitch, this.username, this.userGroups);

    sensorGroup.description = csvFileLine[mappedFields["description"]];
    sensorGroup.beginDate = (csvFileLine[mappedFields["startdate"]] != undefined && csvFileLine[mappedFields["startdate"]] != '') ? moment.utc(csvFileLine[mappedFields["startdate"]]).toDate() : undefined;
    sensorGroup.endDate = (csvFileLine[mappedFields["enddate"]] != undefined && csvFileLine[mappedFields["enddate"]] != '') ? moment.utc(csvFileLine[mappedFields["enddate"]]).toDate() : undefined;

    // Add logic to handle the Action field ("replace" existing, "add or append" to existing, or "delete" the sensor from the sensor group)

    if (csvFileLine[mappedFields["action"]] != undefined && csvFileLine[mappedFields["action"]].toLowerCase() == 'replace') {
      sensorGroup.sensors = [];
    }
    else if (csvFileLine[mappedFields["action"]] != undefined && csvFileLine[mappedFields["action"]].toLowerCase() == 'delete') {
      var uuidsToDelete: string[] = csvFileLine[mappedFields["uuids"]].split(';').map(field => field.trim());
      uuidsToDelete.forEach(x => {
        var sensorIndex = sensorGroup.sensors.findIndex(y => y.uuid.toLowerCase() == x.toLowerCase());
        if (sensorIndex != -1) {
          sensorGroup.sensors.splice(sensorIndex, 1);
        }
      });
    }
    else if (csvFileLine[mappedFields["action"]] != undefined && (csvFileLine[mappedFields["action"]].toLowerCase() == 'add' || csvFileLine[mappedFields["action"]].toLowerCase() == 'append')) {
      // sensors to be added to the existing list of sensors for the sensor group, so do not clear the existing list
    }
    else {
      // If no action is specified, default to "replace" existing sensors with the new list
      sensorGroup.sensors = [];
    }

    if (csvFileLine[mappedFields["action"]].toLowerCase() != 'delete') {
      var uuids: string[] = csvFileLine[mappedFields["uuids"]].split(';').map(field => field.trim());
      uuids.forEach(uuid => { sensorGroup.sensors.push(this.findOrCreateSensor(uuid)); });
    }

    return sensorGroup;
  }


  newSensor(uuid: string): Sensor {
    var newSensor: Sensor = {
      id: 0,
      uuid: uuid.toLowerCase(),
      sensorReadingTypes: null,
      sensorReadingTypeNames: '',
      checked: true,
      modifiedDate: new Date(),
      userName: this.username,
      userGroupId: null,
      lastReading: {
        sensorId: 0,
        isLoaded: false,
        date: undefined,
        displayColor: '',
        waitingForLoad: false
      },
      sensorCalibrationHistory: null,
      virtualSensor: undefined
    };
    return newSensor;
  }


  // importCSVFileContent() {
  //   this.importingCSVFileContents = true;

  //   this.sensorGroupsToImport.forEach(x => {
  //     const sensorGroupInfo = this.common.mapSensorGroup2SensorGroupInfo(x);

  //     if (x.isNew && x.name != '') {
  //       this.onCreate(x, sensorGroupInfo);
  //     }
  //     else if (x.userFeatureAccess["EditSensorGroup"] && x.name != '') {
  //       this.preEditObjectAsJSONString = JSON.stringify(this.sensorGroups.find(y => y.id == x.id));
  //       this.onEdit(x, sensorGroupInfo, this.preEditObjectAsJSONString);
  //     }
  //   });

  //   this.importingCSVFileContents = false;
  // }


  importCSVFileContent() {
    this.importingCSVFileContents = true;

    var sensorGroupInfos: SensorGroupInfo[] = [];
    var preEditSensorGroups: { [key: number] : string } = {};

    this.sensorGroupsToImport.forEach(x => {
      if (x.name != '') {
        sensorGroupInfos.push(this.common.mapSensorGroup2SensorGroupInfo(x));
        preEditSensorGroups[x.id] = JSON.stringify(this.sensorGroups.find(y => y.id == x.id));
      }
    });

    this._sensorGroupService.bulkCreateOrUpdateSensorGroups(sensorGroupInfos).subscribe(
      (results) => {
        if (results != null) {
          this.sensorGroupsToImport.forEach((sensorGroup, i) => {
            if (sensorGroup.id > 0) {
              this.createMessageData(MessageActionType.Edited, sensorGroup, this.common.getEditChanges4SensorGroups(sensorGroup, preEditSensorGroups[sensorGroup.id]));
            }
            else {
              this.createMessageData(MessageActionType.New, sensorGroup, '');
            }
          });
        }
        else {
          this.toastr.warning('Error importing edits. Reload page.');
        }

        this.importingCSVFileContents = false;
        return;
      },
      err => {
        this.toastr.error('Error occurred while updating sensor groups. Reload page.');
        this.importingCSVFileContents = false;
      });

    
  }


  // onEdit(sensorGroup: SensorGroup, sensorGroupInfo: SensorGroupInfo, preEditObjectAsJSONString: string) {
  //   this._sensorGroupService.updateSensorGroup(sensorGroupInfo, this.username).subscribe(
  //     results => {
  //       if (results != null) {
  //         this.createMessageData(MessageActionType.Edited, sensorGroup, this.common.getEditChanges4SensorGroups(sensorGroup, preEditObjectAsJSONString));
  //         this.toastr.success('Sensor Group Updated');
  //       } else {
  //         this.toastr.warning('Error saving edits. Reload page.');
  //       }
  //       return;
  //     },
  //     err => {
  //       this.toastr.error('Error occurred while updating sensor groups. Reload page.');
  //     });
  // }


  // onCreate(sensorGroup: SensorGroup, sensorGroupInfo: SensorGroupInfo) {
  //   this._sensorGroupService.createSensorGroup(sensorGroupInfo).subscribe(
  //     results => {
  //       if (results != null) {
  //         this.createMessageData(MessageActionType.New, sensorGroup, '');
  //         this.toastr.success('Sensor Group Created');
  //       } else {
  //         this.toastr.warning('Error with creating new sensor group. Reload page.');
  //       }
  //       return;
  //     },
  //     err => {
  //       this.toastr.error('Error occurred while adding sensor group. Reload page.');
  //     });
  // }


}
